import { useMemo } from 'react';
import axios from 'axios';

const useApiClient = (accessToken = null) =>
  useMemo(
    () =>
      axios.create({
        baseURL: process.env.REACT_APP_API_URL,
        headers: accessToken
          ? { Authorization: `Bearer ${accessToken}`, Accept: 'application/json' }
          : { Accept: 'application/json' }
      }),
    [accessToken]
  );

export { useApiClient };
